<!--
 * @Author: wzh
 * @Date: 2023-05-31 09:23:24
 * @LastEditTime: 2023-05-31 11:58:51
 * @Description: 账号安全 社交账号绑定
-->
<template>
  <List
    addTitle=""
    ref="table"
    :isChecked="false"
    :loading="loading"
    :columns="columns"
    :dataSource="dataSource"
    :pagination="false"
  >
    <!-- 供应商名称 -->
    <template v-slot:providerName="{ record }">
      <div class="flex_box">
        <img :src="record.icon ? require(`@/${record.icon}`) : defaultIcon" />
        <span>{{ record.providerName }}</span>
        <span>（{{ record.isBindAccount == 1 ? "已绑定" : "未绑定" }}）</span>
      </div>
    </template>

    <!-- 状态-->
    <template v-slot:isBindAccount="{ record }">
      <a-icon v-if="record.isBindAccount == 1" type="check-circle" style="color: #6BD31C;font-size: 18px;" />
    </template>

    <!-- 操作按钮 -->
    <template v-slot:action="{ record }">
      <a-button :type="record.isBindAccount == 1 ? '' : 'primary'" :loading="btnLoading" @click="changeState(record)">
        {{ record.isBindAccount == 1 ? "解除绑定" : "立即绑定" }}
      </a-button>
    </template>
  </List>
</template>
<script>
import List from "@/components/public/list/ant";
import { commonAPI } from "@/apis";
import defaultIcon from "@/assets/images/social/default.png";
import { async } from "q";

export default {
  name: "SocialLogin",
  components: { List },
  data() {
    return {
      defaultIcon,
      loading: false,
      columns: [
        {
          title: "供应商名称",
          dataIndex: "providerName",
          key: "providerName",
          align: "center",
          scopedSlots: { customRender: "providerName" },
        },
        { title: "供应商", dataIndex: "provider", key: "provider", align: "center" },
        { title: "绑定时间", dataIndex: "bindingdate", key: "bindingdate", align: "center" },
        { title: "最近登录时间", dataIndex: "lastLoginDate", key: "lastLoginDate", align: "center" },
        {
          title: "状态",
          dataIndex: "isBindAccount",
          key: "isBindAccount",
          align: "center",
          scopedSlots: { customRender: "isBindAccount" },
        },
        { title: "操作", key: "action", align: "center", width: 180, scopedSlots: { customRender: "action" } },
      ],
      dataSource: [],
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取社交账号列表
    async getList() {
      this.loading = true;
      const { code, data } = await commonAPI.getAction("/socials/associate/list");
      if (code === 0) {
        this.dataSource = data || [];
      } else {
        this.dataSource = [];
      }
      this.loading = false;
    },

    // 绑定及解绑
    async changeState(record) {
      if (record.isBindAccount == 1) {
        // 解除绑定
        this.$confirm({
          title: "提示",
          content: "确认解除绑定吗？",
          onOk: async () => {
            this.btnLoading = true;
            const { code } = await commonAPI.getAction("/socials/associate/delete", {
              userId: record.userId,
              provider: record.provider,
            });
            this.btnLoading = false;
            if (code === 0) {
              this.$message.success("解除绑定成功");
              this.getList();
            } else {
              this.$message.error("解除绑定失败！");
            }
          },
        });
      } else {
        // 绑定账号
        this.btnLoading = true;
        const { code, data, message } = await commonAPI.getAction(`/logon/oauth20/authorize/${record.provider}`, {
          url: "thirdBind",
        });
        this.btnLoading = false;
        if (code == 0) {
          window.location.href = data;
        } else {
          this.$message.error(message);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .flex_box {
    display: flex;
    align-items: center;
    justify-content: center;
    & > * {
      margin-left: 8px;
    }
    & > img {
      width: 30px;
      margin-left: 0;
    }
  }
}
</style>
